export default __webpack_public_path__ + "static/media/3.40afe062.jpeg";